import { useState, ReactNode } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, CircularProgress } from '@material-ui/core';
import { COLORS } from 'src/constants/Color';

const useStyles = makeStyles(() => ({
  card: {
    position: 'relative',
    backgroundColor: COLORS.white,
    borderRadius: 12,
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    border: `1px solid ${COLORS.background}`,
    padding: 16,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    transition: 'background-color 0.2s, border-color 0.2s',
  },
  labelRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    fontSize: 14,
    fontWeight: 700,
    color: COLORS.mediumgrey,
  },
  value: {
    fontFamily: 'Qanelas-Bold',
    fontSize: 20,
    fontWeight: 700,
    marginTop: 6,
  },
  subtitle: {
    fontSize: 11,
    color: COLORS.mediumgrey,
  },
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255,255,255,0.7)',
    borderRadius: 12,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

interface Props {
  icon: ReactNode;
  label: string;
  value: string;
  valueColor: string;
  subtitle: string;
  loading?: boolean;
  hoverColor?: string;
  onClick?: () => void;
}

const SummaryCard = ({
  icon, label, value, valueColor, subtitle, loading = false, hoverColor, onClick,
}: Props) => {
  const classes = useStyles();
  const [hovered, setHovered] = useState(false);

  return (
    <div
      className={classes.card}
      style={{
        backgroundColor: hovered && hoverColor ? hoverColor : COLORS.white,
        borderColor: hovered ? valueColor : COLORS.background,
        cursor: onClick ? 'pointer' : undefined,
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      onKeyDown={onClick ? (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick(); } } : undefined}>
      <div className={classes.labelRow}>
        {icon}
        {label}
      </div>
      <Typography className={classes.value} style={{ color: valueColor }}>
        {value}
      </Typography>
      <div className={classes.subtitle}>
        {subtitle}
      </div>
      {loading && (
        <div className={classes.overlay}>
          <CircularProgress size={24} />
        </div>
      )}
    </div>
  );
};

export default SummaryCard;
